import styles from 'css/components/selector.module.css' 

export const Selector = ({ options, onSelect, style, placeholder, required, value }: { options: string[], onSelect: (option: string | null) => void, style?: string, placeholder?: string, required?: boolean, value?: string }) => {
    return (
        <select
            onChange={(e) => {
                const selectedOption = e.target.value ? options.find(o => o === e.target.value) : null
                onSelect(selectedOption)
            }}
            className={`${style}`}
            value={value ?? ""}
            required={required}
        >
            <option value="" disabled>{placeholder}</option>
            {options.map(o => (
                <option className={styles.option} key={o} value={o}>{o}</option>
            ))}
        </select>
    )
}

export default Selector